'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import Captcha from '@/components/Captcha';
import type { CaptchaProps } from '@/components/Captcha/types';
import { useDonationFormConfig, useDonationFormContext } from '@/donationPages/_dependencies/helpers';
const CAPTCHA_SOLUTION_FIELD_NAME = 'captcha_solution';
const CAPTCHA_ERROR_FIELD_NAME = '_captcha_error';
const CAPTCHA_COMPLETE = '_captcha_complete';
function DonationFormCaptcha() {
  const $ = _c(12);
  const {
    captchaSiteKey,
    captchaEndpoint
  } = useDonationFormConfig();
  const {
    setValue
  } = useDonationFormContext();
  let t0;
  if ($[0] !== setValue) {
    t0 = solution => {
      setValue(CAPTCHA_COMPLETE, true, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
      setValue(CAPTCHA_SOLUTION_FIELD_NAME, solution, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
    };
    $[0] = setValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCaptchaSuccess = t0;
  let t1;
  if ($[2] !== setValue) {
    t1 = (error, value) => {
      setValue(CAPTCHA_COMPLETE, true);
      setValue(CAPTCHA_ERROR_FIELD_NAME, value);
      console.error(error);
    };
    $[2] = setValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onCaptchaError = t1;
  let t2;
  if ($[4] !== setValue) {
    t2 = () => {
      setValue(CAPTCHA_COMPLETE, false);
    };
    $[4] = setValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCaptchaReset = t2;
  const isFakeCaptcha = process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === "test";
  if (isFakeCaptcha) {
    return null;
  }
  let t3;
  if ($[6] !== captchaEndpoint || $[7] !== captchaSiteKey || $[8] !== onCaptchaError || $[9] !== onCaptchaReset || $[10] !== onCaptchaSuccess) {
    t3 = <><Captcha siteKey={captchaSiteKey} endpoint={captchaEndpoint} onSuccess={onCaptchaSuccess} onError={onCaptchaError} onReset={onCaptchaReset} fieldName={CAPTCHA_SOLUTION_FIELD_NAME} /></>;
    $[6] = captchaEndpoint;
    $[7] = captchaSiteKey;
    $[8] = onCaptchaError;
    $[9] = onCaptchaReset;
    $[10] = onCaptchaSuccess;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export default DonationFormCaptcha;